import styled from 'styled-components'
import { Link } from "react-router-dom";
import Search from 'assets/svg/Search.svg'
import colors from 'constants/colors'

export const Container = styled.div`
  width: 100%;
  max-width: 423px;
  align-items: center;
  flex-direction: column;  
  overflow-y: hidden;
  z-index: 200;
  margin-right: 3px;

  ${({ additionalstyle }) => additionalstyle};

  @media only screen and (max-width: 1200px) {
    display: none;
  }
`

export const StyledInput = styled.input`
  width: 100%;
  height: 48px;
  color: ${colors.white};
  font-size: 18px;
  font-weight: 600;
  display: block;
  background-image: url(${Search});
  background-color: ${colors.black3};
  background-repeat: no-repeat;
  background-position: 2% 50%;
  padding: 0 25px 0 40px;
  box-sizing: border-box;
  border: none;
  outline: none;

  :focus {
    border: solid ${colors.white};
    border-width: 2px 2px 2px 2px;
  }
`;

export const StyledList = styled.div`
  max-height: calc(36px * 7);
  overflow-y: auto;
  border: solid ${colors.white};
  border-width: 0px 2px 2px 2px;
`;

export const StyledItem = styled(Link)`
  display: block;
  width: 100%;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  font-weight: normal;
  padding-left: 20px;
  color: ${colors.silver};
  background-color: ${colors.black1};
  overflow: hidden;
  text-decoration: none;

  .title {
    display: flex;
    justify-content: flex-start;

    .type {
      font-style: italic;
      margin-right: 6px;
    }

    .info {
      display: flex;
      gap: 6px;
      min-width: 0;
      .matchedInfo {
        .highlight {
          color: ${colors.white};
          font-weight: bold;
        }
      }
      .secondaryInfo {
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  :hover {
    color: ${colors.lightBlue};
    border-left: 5px solid ${colors.lightBlue};
    background-color: ${colors.darkBlue};
    padding-left: 15px;

    .highlight {
      font-weight: bold;
      color: ${colors.lightBlue};
    }
  }
`;